'use es6';

import Hubs from 'self-service-api/constants/Hubs';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { BUY_TOUCHLESS, TALK_TO_SALES, TALK_TO_SALES_FALLBACK } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { makeRequestStatusSelector } from 'pricing-pages-unified-ui/selectors/RequestStatusSelectors';
import { FetchPurchaseMotionRequestTypes } from 'pricing-pages-unified-ui/actions/PurchaseMotionActions';
import { productForSkuIdSelector } from './ProductsSelectors';
import { hubToProductLine } from 'self-service-api/constants/ProductLineToHub';
import { canUpgradeToProductLevelSuiteSelector } from './UpgradeSelectors';
import { isDevPortalSelector } from './ScopeSelectors';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { hasPurchaseMotionsSucceededSelector } from './LoadingStateSelectors';
import { isHubSpotBETPortal } from 'pricing-pages-lib/utils/portalUtils';
export const fetchPurchaseMotionStatus = makeRequestStatusSelector(FetchPurchaseMotionRequestTypes.REQUEST);

const allPurchaseMotionsSelector = state => {
  return state.purchaseMotionsByLocation;
};

export const purchaseMotionsSelector = (state, {
  location = MERCH_CARD,
  skuId
}) => {
  const {
    apiName
  } = productForSkuIdSelector(state, {
    skuId
  });
  const allPurchaseMotions = allPurchaseMotionsSelector(state, {
    location
  });
  let purchaseMotions = apiName && allPurchaseMotions && allPurchaseMotions[location] && allPurchaseMotions[location].purchaseMotions[apiName];
  if (!purchaseMotions) purchaseMotions = [];

  if (isDevPortalSelector(state)) {
    purchaseMotions = purchaseMotions.filter(({
      key
    }) => key !== BUY_TOUCHLESS);
  }

  return purchaseMotions.map(({
    key
  }) => key);
};
export const talkToSalesTypeSelector = state => {
  const allPurchaseMotions = allPurchaseMotionsSelector(state);

  if (allPurchaseMotions) {
    for (const location of Object.keys(allPurchaseMotions)) {
      for (const apiName of Object.keys(allPurchaseMotions[location].purchaseMotions)) {
        const purchaseMotionsObjectArray = allPurchaseMotions[location].purchaseMotions[apiName];
        const purchaseMotions = purchaseMotionsObjectArray.map(({
          key
        }) => key);
        if (purchaseMotions.includes(TALK_TO_SALES)) return TALK_TO_SALES;
        if (purchaseMotions.includes(TALK_TO_SALES_FALLBACK)) return TALK_TO_SALES_FALLBACK;
      }
    }
  }

  return TALK_TO_SALES_FALLBACK;
};
export const talkToSalesTypeSelector_DEPRECATED = (state, hub) => {
  const productLine = hubToProductLine[hub];
  return talkToSalesTypeSelector(state, {
    productLine
  });
};

const hasNoPurchaseMotionsSelector = state => {
  const purchaseMotions = allPurchaseMotionsSelector(state);
  const hasPurchaseMotionsSucceeded = hasPurchaseMotionsSucceededSelector(state);
  return hasPurchaseMotionsSucceeded && Object.keys(purchaseMotions).length === 0;
};

export const commonPurchaseMotionsSelector = (state, {
  skuIds,
  location
}) => {
  const foundPurchaseMotions = {};
  skuIds.forEach(skuId => purchaseMotionsSelector(state, {
    location,
    skuId
  }).forEach(purchaseMotion => {
    if (purchaseMotion in foundPurchaseMotions) {
      foundPurchaseMotions[purchaseMotion]++;
    } else {
      foundPurchaseMotions[purchaseMotion] = 1;
    }
  }));
  const commonPurchaseMotions = Object.keys(foundPurchaseMotions).filter(purchaseMotion => foundPurchaseMotions[purchaseMotion] === skuIds.length);
  const hasNoPurchaseMotions = hasNoPurchaseMotionsSelector(state);

  if (!commonPurchaseMotions.length && !hasNoPurchaseMotions) {
    return [talkToSalesTypeSelector(state)];
  }

  return commonPurchaseMotions;
};
export const suitePurchaseMotionsMapSelector = state => {
  const hasNoPurchaseMotions = hasNoPurchaseMotionsSelector(state);

  if (hasNoPurchaseMotions) {
    return {};
  }

  return Object.keys(CRM_SUITE_PRODUCTS).reduce((acc, productLevel) => {
    const canUpgradeToProductLevelSuite = canUpgradeToProductLevelSuiteSelector(state, {
      productLevel
    });
    const ttsType = talkToSalesTypeSelector_DEPRECATED(state, Hubs.HUB_MARKETING);

    if (!canUpgradeToProductLevelSuite || productLevel !== STARTER) {
      return Object.assign({}, acc, {
        [productLevel]: [ttsType]
      });
    }

    return Object.assign({}, acc, {
      [productLevel]: [PurchaseMotionTypes.BUY_TOUCHLESS, ttsType]
    });
  }, {});
};
export const isRussianBlockedSelector = state => {
  const hasNoPurchaseMotions = hasNoPurchaseMotionsSelector(state);
  const isHSPortal = isHubSpotBETPortal();
  return hasNoPurchaseMotions && !isHSPortal;
};